import React, { useState, useEffect } from 'react';
import './Snackbar.css';

export const Snackbar = ({ message, isVisible, onClose }) => {
  useEffect(() => {
    if (isVisible && message) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, message, onClose]);

  if (!isVisible) return null;

  return (
    <div className="snackbar" onClick={onClose}>
      {message}
    </div>
  );
};

// Utility function to show snackbar (for use outside of React components)
export const showSnackbar = (message) => {
  // This will be used by the global snackbar context
  if (window.showSnackbarGlobal) {
    window.showSnackbarGlobal(message);
  }
}; 